import { generateUtilityClasses } from '@mui/material';

// generateUtilityClasses가 이미 타입을 제공하므로 별도 인터페이스 불필요
export const tableHeadClasses = generateUtilityClasses('TableHead', ['root']);

// ✅ theme 등록 완전 제거 (styleOverrides가 모두 컴포넌트로 이전되었음)
